import Menu, { MenuProps } from "antd/lib/menu";
import Select from "rivals/components/shared/Form/Select";
import {
  SelectOption,
  SelectVariant
} from "rivals/components/shared/Form/Select/types";
import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";
import { MobileMenuProps, OwnProps } from "./types";

type MenuItem = Required<MenuProps>["items"][number];

const MobileMenu = ({
  data,
  options,
  placeholder,
  value,
  onChange
}: MobileMenuProps): JSX.Element => {
  const buildItems = (): MenuItem[] => {
    const children: MenuItem[] = [];
    options.forEach((option: SelectOption<string>) => {
      children.push({
        key: option.value,
        label: <div>{option.name}</div>
      });
    });

    return [
      {
        children: children,
        disabled: !options.length,
        key: placeholder,
        label: <span>{placeholder}</span>
      }
    ];
  };
  const items = buildItems();

  return (
    <Menu
      className={styles.menu}
      items={items}
      mode="inline"
      onClick={({ key }): void => {
        const newValue = key !== value ? key.toString() : "";
        onChange(newValue, false);
      }}
      selectedKeys={value ? [value] : undefined}
      {...setData(data, "menu")}
    />
  );
};

const ResponsiveFilter = ({
  data = "",
  className = "",
  onChange,
  isMobile,
  ...props
}: OwnProps): JSX.Element => {
  if (!isMobile) {
    return (
      <Select<string>
        allowClear={!!props.value}
        className={className}
        data={data}
        disabled={!props.options.length}
        dropdownClassName={styles.dropdown}
        onChange={(value): void => onChange(value, true)}
        variant={SelectVariant.BORDER_ROUND}
        {...props}
      />
    );
  } else {
    return (
      <MobileMenu
        data={data}
        onChange={onChange}
        options={props.options}
        placeholder={props.placeholder}
        value={props.value}
      />
    );
  }
};

export default ResponsiveFilter;
